import { useMemo } from "react"

import type { BreadcrumbNode } from "@/components/Layout"

const breadcrumbRegistry: Record<string, BreadcrumbNode[]> = {
  "dashboard.root": [{ label: "Dashboard", href: "/" }],
  "questions.index": [
    { label: "Dashboard", href: "/" },
    { label: "Questions", href: "/questions" },
  ],
  "questions.analytics": [
    { label: "Dashboard", href: "/" },
    { label: "Questions", href: "/questions" },
    { label: "Analytics" },
  ],
  "quiz-management.index": [
    { label: "Dashboard", href: "/" },
    { label: "Quiz Management", href: "/quiz-management" },
  ],
  "quiz-management.analytics": [
    { label: "Dashboard", href: "/" },
    { label: "Quiz Management", href: "/quiz-management" },
    { label: "Analytics" },
  ],
  "flashcards.index": [
    { label: "Dashboard", href: "/" },
    { label: "Flashcards", href: "/flashcards" },
  ],
  "study.index": [
    { label: "Dashboard", href: "/" },
    { label: "Study", href: "/study" },
  ],
  "quizzes.index": [
    { label: "Dashboard", href: "/" },
    { label: "Quizzes", href: "/quizzes" },
  ],
  "quizzes.detail": [
    { label: "Dashboard", href: "/" },
    { label: "Quizzes", href: "/quizzes" },
    { label: "Details" },
  ],
  "quizzes.attempt": [
    { label: "Dashboard", href: "/" },
    { label: "Quizzes", href: "/quizzes" },
    { label: "Attempt" },
  ],
  "organizations.index": [
    { label: "Dashboard", href: "/" },
    { label: "Organizations", href: "/organizations" },
  ],
  "organizations.school-analytics": [
    { label: "Dashboard", href: "/" },
    { label: "Organizations", href: "/organizations" },
    { label: "School Analytics" },
  ],
  "admin.users": [
    { label: "Dashboard", href: "/" },
    { label: "Admin", href: "/admin" },
    { label: "Users" },
  ],
  "practice-quizzes.index": [
    { label: "Dashboard", href: "/" },
    { label: "Practice Quizzes", href: "/practice-quizzes" },
  ],
  "feedback.org": [
    { label: "Dashboard", href: "/" },
    { label: "Feedback", href: "/feedback" },
  ],
  "feedback.mine": [
    { label: "Dashboard", href: "/" },
    { label: "My Feedback", href: "/my-feedback" },
  ],
  "settings.index": [
    { label: "Dashboard", href: "/" },
    { label: "Settings", href: "/settings" },
  ],
  "subjects.index": [
    { label: "Dashboard", href: "/" },
    { label: "Subjects", href: "/subjects" },
  ],
  "programs.index": [
    { label: "Dashboard", href: "/" },
    { label: "Programs", href: "/programs" },
  ],
  "programs.detail": [
    { label: "Dashboard", href: "/" },
    { label: "Programs", href: "/programs" },
  ],
  "admin-topics.index": [
    { label: "Dashboard", href: "/" },
    { label: "Topics", href: "/admin-topics" },
  ],
  "admin-topic-proposals.index": [
    { label: "Dashboard", href: "/" },
    { label: "Topics", href: "/admin-topics" },
    { label: "Topic Proposals" },
  ],
  "admin-topic-merge.index": [
    { label: "Dashboard", href: "/" },
    { label: "Topics", href: "/admin-topics" },
    { label: "Topic Merges" },
  ],
  "attempts-history.index": [
    { label: "Dashboard", href: "/" },
    { label: "Attempts History", href: "/attempts-history" },
  ],
}

export function getBreadcrumbTrail(id?: string) {
  if (!id) {
    return []
  }

  return breadcrumbRegistry[id] ?? []
}

export function useRouteBreadcrumbs(
  id?: string,
  additional: BreadcrumbNode[] = [],
) {
  return useMemo(() => {
    const base = getBreadcrumbTrail(id)
    if (!additional.length) {
      return base
    }

    return [...base, ...additional]
  }, [id, additional])
}

export function registerBreadcrumbTrail(id: string, nodes: BreadcrumbNode[]) {
  breadcrumbRegistry[id] = nodes
}
